module.exports = __webpack_public_path__ + "img/check.9042e9fc.svg";